module.exports = __webpack_public_path__ + "static/media/harrypotter.352e1aad.jpg";